import type { HasFirstViewportVariant } from '@silvertours/front-entities';
import { LandingPage } from './LandingPage';
import { LandingPageProps } from './content';

/**
 * The de index page with the variant first viewport (A/B test).
 * Akamai rewrites "/" to the page that renders this component. The app reads
 * `firstViewportVariant` and provides it to the site layout and to the page.
 */
const HomeVariantLandingPage = (props: LandingPageProps) => (
  <LandingPage {...props} />
);

HomeVariantLandingPage.firstViewportVariant =
  'variant' satisfies HasFirstViewportVariant['firstViewportVariant'];

export { HomeVariantLandingPage };
